module.exports = __webpack_public_path__ + "static/pattern3-1feb44c7c9fa4946568a978d1fc53cf6.png";